import Papa from "papaparse";
// import csvFile from "../../data/HecoRep_Form_Template.csv";

export async function parseCSVtoJSON(csvData){

  const parseResult = await new Promise((resolve, reject)=>{
    //parse the data into JSON
    Papa.parse(csvData, {
      header: false, //header needs to be false so we can set our own headers
      skipEmptyLines: true, //skip empty lines

      complete: (results) => resolve(results),
      error: (error) => reject(error),
    });
  });

        const keys = parseResult.data[0]; //make keys the row 0 (second row)
        const dataRows = parseResult.data.slice(1); // make values from row 1 (second row onwards)

        //Extract common data from the second row
        const commonData = {
          CompanyNameEditable: dataRows[0][0], //companyNameEditable value in file
          CompanyName: dataRows[0][1], //Company Name value in the file
        };

           //Loop from the second column onwards, pair keys with values (we do not want to include Company Editable and Company Name again)
    const formatCSVData = (keys, values) => {
      const formattedData = {};
      for (let i = 2; i < keys.length; i++) {
   
      if (keys[i] !== "") {
        //do not display keys that are empty strings
        formattedData[keys[i]] = values[i];
      }
    }

    return formattedData;
    }
        //map the format data to the key-value pairs
        const formattedDataArray = dataRows.map((values) =>
        formatCSVData(keys, values)
      );

      return {
        formattedDataArray,
        CompanyNameEditable: commonData["CompanyNameEditable"],
        companyName: commonData["CompanyName"],
      };
    
  };
      
 
